// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
}

.login_page_left,
.login_page_right {
  max-width: calc(100% / 2);
  width: 100%;
}
.login_page_left {
  height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.login_page_left:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(5, 113, 185, 0.7);
}
.login_page_left img {
  height: 100%;
  object-fit: cover;
  width: 100%;
  mix-blend-mode: multiply;
}

.login_page_right {
  padding: 0 80px;
}

.login_inner_logo {
  text-align: center;
}

.login_inner_bottom {
  width: 100%;
  padding: 20px;
  border-radius: 10px;
  background: #0571b9;
  margin-top: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}

.login_field {
  height: 50px;
  border: 0px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
.login_field::placeholder {
  color: #000;
}
.login_inner_bottom label {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
}

.forgot_pass {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}

.forgot_pass button {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-decoration: underline;
  background: transparent;
  border: 0px;
}

.login_submit {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.login_submit .sub_log_but {
  height: 40px;
  line-height: 40px;
  padding: 0 60px;
  color: #fff;
  border: 0px;
  background: rgb(36, 57, 119);
  border-radius: 10px;
  box-shadow: 0 0 30px rgba(36, 57, 119, 0.65);
}
.loading_overlay ._loading_overlay_overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  background: rgba(255, 255, 255, 0.9);
}
.loading_overlay ._loading_overlay_overlay ._loading_overlay_content {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  animation: Blink 3s alternate infinite;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-position: center center;
}
.another_logo img {
  width: 200px;
  height: auto;
  display: block;
  margin: auto;
}

.another_logo span {
  display: block;
  font-size: 14px;
  margin: 10px 0px;
  text-align: center;
}
@keyframes Blink {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.max-100 {
  max-width: 100%;
}

.loading_overlay ._loading_overlay_content p {
  margin-top: 200px;
  font-size: 22px;
  line-height: 30px;
  color: #000;
  /* animation: Blink 1s alternate infinite; */
}

.trip_text {
  font-size: 26px;
  color: #000;
  font-weight: 600;
  line-height: 32px;
  text-align: center;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  border-radius: 7px;
}

.login_page_left .trip_text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 10px 20px;
}

.trip_text_holder {
  text-align: center;
}
@media screen and (max-width: 1199px) {
  .login_page_right {
    padding: 0 20px;
  }
}

@media screen and (max-width: 767px) {
  .login_page {
    flex-wrap: wrap;
    height: 100%;
  }
  .login_page_left,
  .login_page_right {
    max-width: 100%;
  }

  .login_page_right {
    margin-top: 30px;
  }

  .login_inner_logo img {
    max-width: 100%;
    height: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,mDAA6C;EAC7C,sCAAsC;EACtC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;EACA;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".login_page {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n}\n\n.login_page_left,\n.login_page_right {\n  max-width: calc(100% / 2);\n  width: 100%;\n}\n.login_page_left {\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n}\n.login_page_left:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(5, 113, 185, 0.7);\n}\n.login_page_left img {\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n  mix-blend-mode: multiply;\n}\n\n.login_page_right {\n  padding: 0 80px;\n}\n\n.login_inner_logo {\n  text-align: center;\n}\n\n.login_inner_bottom {\n  width: 100%;\n  padding: 20px;\n  border-radius: 10px;\n  background: #0571b9;\n  margin-top: 30px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n}\n\n.login_field {\n  height: 50px;\n  border: 0px;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n}\n.login_field::placeholder {\n  color: #000;\n}\n.login_inner_bottom label {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.forgot_pass {\n  margin-top: 14px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.forgot_pass button {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  text-decoration: underline;\n  background: transparent;\n  border: 0px;\n}\n\n.login_submit {\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n}\n\n.login_submit .sub_log_but {\n  height: 40px;\n  line-height: 40px;\n  padding: 0 60px;\n  color: #fff;\n  border: 0px;\n  background: rgb(36, 57, 119);\n  border-radius: 10px;\n  box-shadow: 0 0 30px rgba(36, 57, 119, 0.65);\n}\n.loading_overlay ._loading_overlay_overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: block;\n  background: rgba(255, 255, 255, 0.9);\n}\n.loading_overlay ._loading_overlay_overlay ._loading_overlay_content {\n  background: url(../../assets/images/logo.png);\n  animation: Blink 3s alternate infinite;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-position: center center;\n}\n.another_logo img {\n  width: 200px;\n  height: auto;\n  display: block;\n  margin: auto;\n}\n\n.another_logo span {\n  display: block;\n  font-size: 14px;\n  margin: 10px 0px;\n  text-align: center;\n}\n@keyframes Blink {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.max-100 {\n  max-width: 100%;\n}\n\n.loading_overlay ._loading_overlay_content p {\n  margin-top: 200px;\n  font-size: 22px;\n  line-height: 30px;\n  color: #000;\n  /* animation: Blink 1s alternate infinite; */\n}\n\n.trip_text {\n  font-size: 26px;\n  color: #000;\n  font-weight: 600;\n  line-height: 32px;\n  text-align: center;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  border-radius: 7px;\n}\n\n.login_page_left .trip_text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #fff;\n  padding: 10px 20px;\n}\n\n.trip_text_holder {\n  text-align: center;\n}\n@media screen and (max-width: 1199px) {\n  .login_page_right {\n    padding: 0 20px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .login_page {\n    flex-wrap: wrap;\n    height: 100%;\n  }\n  .login_page_left,\n  .login_page_right {\n    max-width: 100%;\n  }\n\n  .login_page_right {\n    margin-top: 30px;\n  }\n\n  .login_inner_logo img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
